import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { useTranslation } from 'react-i18next'
import { RentalListPage } from '@/components/rental-list-page'

const searchSchema = z.object({
	propertyId: z.string().optional(),
})

export const Route = createFileRoute('/_app/rent/upcoming')({
	validateSearch: searchSchema,
	component: RentUpcomingPage,
})

function RentUpcomingPage() {
	const { t } = useTranslation()
	const { propertyId } = Route.useSearch()
	return (
		<RentalListPage
			status="UPCOMING"
			initialPropertyId={propertyId}
			emptyTitle={t('rent.upcoming.emptyTitle')}
			emptyDescription={t('rent.upcoming.emptyDescription')}
		/>
	)
}
